import { PauseCircleIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Card, CardContent } from '@/components'
import { SelectPlanForm } from '@/modules/auth'
import { BaseError } from './BaseError'

const Forbidden = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <BaseError
      title="Your plan is inactive"
      description="It looks like you don't have an active plan to access the application."
      icon={PauseCircleIcon}
      withLogout
      {...props}
      ref={ref}
    >
      <Card className="w-md max-w-full lg:shrink-0 mx-auto lg:mx-0 text-left">
        <CardContent className="px-4 sm:px-6 md:px-7 lg:px-6 xl:px-7 p-6">
          <SelectPlanForm />
        </CardContent>
      </Card>
    </BaseError>
  )
})

Forbidden.displayName = 'Forbidden'

export { Forbidden }
